import { render, staticRenderFns } from "./BirthdaysAnniversaries.vue?vue&type=template&id=39374f9d&"
import script from "./BirthdaysAnniversaries.vue?vue&type=script&lang=js&"
export * from "./BirthdaysAnniversaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports